export default __webpack_public_path__ + "static/media/UB.1fdd2eae.svg";